import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MaterialModule} from '../material/material.module';
import {UtilitiesModule} from '../utilities/utilities.module';
import { GlobalServicesComponent } from './components/global-services/global-services.component';
import {GlobalServicesService} from './services/global-services.service';
import { GlobalServicesTableComponent } from './components/global-services-table/global-services-table.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { GlobalServicesSetTimeComponent } from './components/global-services-set-time/global-services-set-time.component';
import {MdDialogModule} from '@angular/material';

@NgModule({
  declarations: [GlobalServicesComponent, GlobalServicesTableComponent, GlobalServicesSetTimeComponent],
  entryComponents: [
    GlobalServicesSetTimeComponent
  ],
  providers: [GlobalServicesService],
  imports: [
    CommonModule,
    MaterialModule,
    UtilitiesModule,
    FormsModule,
    ReactiveFormsModule,
    MdDialogModule
  ],
})
export class GlobalServiceScheduleModule {}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/global-service-schedule/global-service-schedule.module.ts